import React from "react";
import { Routes, Route, Navigate } from "react-router-dom"; // Se agregó Navigate
import PublicLayout from "./utils/PublicLayout";

import Inicio from "./pages/Inicio";
import Rutas from "./pages/Rutas";
import Exportacion from "./pages/Exportacion";
import Importacion from "./pages/Importacion";
import Cotizar from "./pages/Cotizar";
import Agencias from "./pages/Agencias";
import AgenciaDetalle from "./pages/AgenciaDetalle";
import Aduanas from "./pages/AduanasPuertos";
import Mapa from "./pages/Mapa";
import Calculo from "./pages/Calculo";
import FormularioEmpresa from "./pages/FormularioSolicitudRegistro";
import Transportistas from "./pages/Transportistas";
import AduanaDetalle from './pages/AduanaDetalle';
import PuertoDetalle from './pages/PuertoDetalle';
import TransportistaDetalle from "./pages/TransportistaDetalle";

import Dashboard from "./pages/admin/DashBoard";
import Aseguradoras from "./pages/admin/Aseguradoras";
import AdminLayout from "./utils/AdminLayout";
import CorredorPublico from "./pages/admin/CorredorPublico";
import Puertos from "./pages/admin/Puertos";
import Aduanass from "./pages/admin/Aduanas";
import Transportistass from "./pages/admin/Transportistas";
import GestionServicios from "./pages/admin/Servicios";
import Solicitudes from "./pages/admin/Solicitudes";
import Empresas from "./pages/admin/Empresas";
import AgenteAduanal from "./pages/admin/AgenteAduanal";
import AgenteNavieroAdmin from "./pages/admin/AgenteNaviero";
import RutasFerroviarias from "./pages/admin/RutasFerroviarias";
import Estaciones from "./pages/admin/Estaciones";

import Login from './pages/Login';

import FormularioCorredor from "./pages/admin/FormularioCorredor";
import FormularioPuerto from "./pages/admin/FormularioPuerto";
import FormularioAseguradora from "./pages/admin/FormularioAseguradora";
import FormularioAduana from "./pages/admin/FormularioAduana";
import FormularioTransportista from "./pages/admin/FormularioTransportista";
import FormularioAgenteAduanal from "./pages/admin/FormularioAgenteAduanal";
import FormularioAgenteNaviero from "./pages/admin/FormularioAgenteNaviero";
import FormularioEstacion from "./pages/admin/FormularioEstaciones"; 
import FormularioRuta from "./pages/admin/FormularioRuta";
import ConfiguracionBanner from "./pages/admin/ConfiguracionBanner"; 

import SessionMonitor from "./components/SessionMonitor"; 

const parseJwt = (token) => {
  try {
    // 1. Dividir el token y tomar la segunda parte (el payload)
    const base64Url = token.split('.')[1];
    
    // 2. Reemplazar caracteres URL-safe para que atob pueda leerlo
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    
    // 3. Decodificar Base64 a String y luegar parsear a JSON
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  } catch (e) {
    // Si el token tiene formato inválido, retornamos null
    return null;
  }
};

/**
 * Componente Wrapper Protegido
 */
const RutaProtegida = ({ children }) => {
  const token = localStorage.getItem("token");

  // 1. Si no hay token físico, adiós.
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // 2. Intentamos decodificarlo
  const decodedToken = parseJwt(token);

  // Si no se pudo decodificar (token basura), limpiar y salir
  if (!decodedToken) {
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  // 3. Verificar fecha de expiración (exp viene en segundos, Date.now en milisegundos)
  const currentTime = Date.now() / 1000;

  if (decodedToken.exp < currentTime) {
    // El token ya caducó
    console.log("Token expirado. Redirigiendo...");
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  // Si todo está bien:
  return (
    <>
      <SessionMonitor />
      {children}
    </>
  );
};

export default function App() {
  return (
    <>

      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<PublicLayout />}>
          <Route path="/" element={<Inicio />} />
          <Route path="/rutas" element={<Rutas />} />
          <Route path="/exportacion" element={<Exportacion />} />
          <Route path="/importacion" element={<Importacion />} />
          <Route path="/cotizar" element={<Cotizar />} />
          <Route path="/agencias" element={<Agencias />} />
          <Route path="/agencia/:id" element={<AgenciaDetalle />} />
          <Route path="/aduanas-puertos" element={<Aduanas />} />
          <Route path="/mapa" element={<Mapa />} />
          <Route path="/calculo" element={<Calculo />} />
          <Route path="/formulario-empresa" element={<FormularioEmpresa />} />
          <Route path="transportistas" element={<Transportistas />} />
          <Route path="/aduanas/:id" element={<AduanaDetalle />} />
          <Route path="/puerto/:id" element={<PuertoDetalle />} />
          <Route path="/transportista/:id" element={<TransportistaDetalle/>} />
        </Route>


        <Route path="/admin" element={
            <RutaProtegida>
              <AdminLayout />
            </RutaProtegida>
        }>
          <Route index element={<Dashboard />} /> 
          
          <Route path="aseguradoras" element={<Aseguradoras />} />
          <Route path="aseguradoras/agregar" element={<FormularioAseguradora />} />
          <Route path="aseguradoras/editar/:id" element={<FormularioAseguradora />} />
          
          <Route path="corredorPublico" element={<CorredorPublico />} />
          <Route path="corredorPublico/agregar" element={<FormularioCorredor />} />
          <Route path="corredorPublico/editar/:id" element={<FormularioCorredor />} />
          
          <Route path="puertos" element={<Puertos />} />
          <Route path="puertos/agregar" element={<FormularioPuerto />} />
          <Route path="puertos/editar/:id" element={<FormularioPuerto />} />
          
          <Route path="servicios" element={<GestionServicios/>} />
          <Route path="solicitudes" element={<Solicitudes/>} />
          <Route path="empresas" element={<Empresas/>} />

          <Route path="aduanas" element={<Aduanass />} />
          <Route path="aduanas/agregar" element={<FormularioAduana />} />
          <Route path="aduanas/editar/:id" element={<FormularioAduana />} />

          <Route path="agenteNaviero" element={<AgenteNavieroAdmin />} />
          <Route path="agenteNaviero/agregar" element={<FormularioAgenteNaviero />} />
          <Route path="agenteNaviero/editar/:id" element={<FormularioAgenteNaviero />} />
          
          <Route path="transportistas" element={<Transportistass />} />
          <Route path="transportistas/agregar" element={<FormularioTransportista />} />
          <Route path="transportistas/editar/:id" element={<FormularioTransportista />} />

          <Route path="agenteAduanal" element={<AgenteAduanal />} />
          <Route path="agenteAduanal/agregar" element={<FormularioAgenteAduanal />} />
          <Route path="agenteAduanal/editar/:id" element={<FormularioAgenteAduanal />} />

          <Route path="rutas" element={<RutasFerroviarias />} />
          <Route path="rutas/agregar" element={<FormularioRuta />} />
          <Route path="rutas/editar/:id" element={<FormularioRuta />} />

          <Route path="estaciones" element={<Estaciones />} />
          <Route path="estaciones/agregar" element={<FormularioEstacion />} />
          <Route path="estaciones/editar/:id" element={<FormularioEstacion />} />

          <Route path="banner" element={<ConfiguracionBanner />} />
        </Route>
      </Routes>
    </>
  );
}